import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildUrl = (endpoint) =>
  `${API_ROUTES.BOOK.BASE}${API_ROUTES.BOOK.SAVED_TOURS}/${endpoint ? endpoint : ""}`

export const savedToursBrandingService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBrandingSettings: builder.query({
      query: () => ({
        url: buildUrl("branding"),
        method: "GET",
      }),
      providesTags: [{ type: "SavedToursBrandingSettings", id: "CURRENT" }],
    }),
    updateBrandingSettings: builder.mutation({
      query: (body) => ({
        url: buildUrl("branding"),
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "SavedToursBrandingSettings", id: "CURRENT" }],
    }),
  }),
})

export const { useGetBrandingSettingsQuery, useUpdateBrandingSettingsMutation } =
  savedToursBrandingService
